import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import ButtonView from 'components/button/ButtonView'

const getLandscapeWidth = props => (props.full ? '100%' : 'calc(50% - 10px)')

const StyledButtonView = styled(ButtonView)`
  ${breakpoint('portrait')`
     width: 100%;
  `};

  ${breakpoint('landscape')`
     width: ${getLandscapeWidth};
  `};
`

export default StyledButtonView
